var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99414 5.7189C8.99414 5.40768 8.99414 5.25207 8.89233 5.16247C8.79052 5.07288 8.63902 5.0923 8.33603 5.13113C6.09343 5.41858 4.53026 6.00417 3.33729 7.19715C0.994141 9.5403 0.994141 13.3115 0.994141 20.854C0.994141 28.3965 0.994141 32.1677 3.33729 34.5109C5.68043 36.854 9.45167 36.854 16.9941 36.854H20.9941C28.5366 36.854 32.3078 36.854 34.651 34.5109C36.9941 32.1677 36.9941 28.3965 36.9941 20.854C36.9941 13.3115 36.9941 9.5403 34.651 7.19715C33.458 6.00417 31.8949 5.41858 29.6523 5.13114C29.3493 5.0923 29.1978 5.07288 29.096 5.16247C28.9941 5.25207 28.9941 5.40768 28.9941 5.7189L28.9941 9.854C28.9942 11.5109 27.651 12.854 25.9942 12.854C24.3373 12.854 22.9942 11.5109 22.9941 9.85401L22.9941 5.45411C22.9941 5.17195 22.9941 5.03088 22.9064 4.94303C22.8187 4.85519 22.6778 4.855 22.3959 4.85462C21.9437 4.854 21.4766 4.854 20.9941 4.854H16.9941C16.5117 4.854 16.0446 4.854 15.5924 4.85462C15.3105 4.855 15.1696 4.85519 15.0819 4.94303C14.9941 5.03088 14.9941 5.17196 14.9941 5.45411L14.9941 9.854C14.9942 11.5109 13.651 12.854 11.9942 12.854C10.3373 12.854 8.99415 11.5109 8.99415 9.85401L8.99414 5.7189Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 1.85352L11.9941 9.85352",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9961 1.85352L25.9961 9.85352",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99414,
    cy: 17.8535,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9961,
    cy: 17.8535,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9961,
    cy: 17.8535,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9941,
    cy: 17.8535,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99414,
    cy: 23.854,
    r: 1,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9961,
    cy: 23.854,
    r: 1,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9961,
    cy: 23.854,
    r: 1,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9941,
    cy: 23.854,
    r: 1,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99402,
    cy: 29.8535,
    r: 1,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9961,
    cy: 29.8535,
    r: 1,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9961,
    cy: 29.8535,
    r: 1,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9941,
    cy: 29.8535,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdos);
export default __webpack_public_path__ + "static/media/idos.3ea30ca5ad3133a78b21aaa6df7265f2.svg";
export { ForwardRef as ReactComponent };